import request from '@/utils/request'
export function selectAmountByOperator(data) {
    return request({
        url: `api/serviceCenter/orderManagement/selectAmountByOperator`,
        method: 'post',
        data,
    })
}


export function downLoadAmountByOperator(data) {
    return request({
      url: `api/serviceCenter/orderManagement/downLoadAmountByOperator`,
      method: 'post',
      responseType: 'blob',
      data
    })
  }